export const config = {
  title: "Blake Reaves | Fathom Realty - Real Estate Agent in Chapel Hill, NC",
  meta: {
    description:
      "Blake Reaves is a trusted Fathom Realty agent serving Chapel Hill and surrounding areas. Specializing in buying and selling homes across the Triangle.",
    keywords: [
      "Blake Reaves real estate",
      "Fathom Realty Chapel Hill",
      "buy homes Chapel Hill NC",
      "Triangle real estate expert",
      "Blake Reaves realtor"
    ],
    author: "Blake Reaves | Fathom Realty",
    canonicalUrl: "https://www.blakesellstriangle.com/blake-reaves/",
  },
  sections: {
    header: {
      businessName: "Blake Reaves | Fathom Realty",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner",
      heroSubtitle: "Helping you buy or sell your next home in Chapel Hill and across the Triangle.",
      learnAboutText: "Contact Blake Today",
      phoneNumber: "9192718337",
      phoneLabel: "(919) 271-8337",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2163132165/photo/houses-align-a-residential-district-next-to-road.jpg?s=612x612&w=0&k=20&c=JwTatZ7qyrv0s0UZa6yZ_WpByb_0M7GN9ZXZQOrWWRk=",
      cardData: [
        {
          title: "Buy a Home",
          description: "Explore properties that fit your needs and budget.",
        },
        {
          title: "Sell Your Home",
          description: "Get the best value and guidance from listing to closing.",
        },
        {
          title: "Relocation Help",
          description: "Moving into the Triangle? We’ll make the transition seamless.",
        },
      ],
      description:
        "With deep knowledge of the Chapel Hill and Triangle real estate market, Blake Reaves provides unmatched service to buyers and sellers seeking success.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Let Blake guide you through buying, selling, and relocating with confidence and clarity.",
      cards: [
        {
          title: "Home Buying",
          description: "Personalized home search and negotiation strategy.",
          imageSrc: "https://media.istockphoto.com/id/1567383839/photo/real-estate-concept-business-home-insurance-and-real-estate-protection-buy-and-sell-houses.jpg?s=612x612&w=0&k=20&c=jrBOzY275KW_ahIWkv-ZRC_TVNpAkPPHaztdCBhrk18=",
          imageAlt: "Home Buying",
        },
        {
          title: "Home Selling",
          description: "Professional listings, open house support, and more.",
          imageSrc: "https://media.istockphoto.com/id/2197655235/photo/close-up-of-three-people-looking-at-financial-data-with-graphs-and-charts.jpg?s=612x612&w=0&k=20&c=rOX0dS9sbA5EaYkcj-UdjeboXoopcu4-dy6qp0XJy_c=",
          imageAlt: "Home Selling",
        },
        {
          title: "Market Analysis",
          description: "Understand your home's market value and position.",
          imageSrc: "https://media.istockphoto.com/id/2155527498/photo/asian-businesswoman-discusses-home-purchase-contracts-with-clients-at-her-desk-focusing-on.jpg?s=612x612&w=0&k=20&c=vSLUrcEeGPlL_P0BFxzMK03Cfcuiaz4Z2R17whH4auI=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Why Choose Blake?",
      otherServicesList: [
        "Experienced Local Realtor",
        "Triangle Market Expertise",
        "Client-First Approach",
        "Responsive Communication",
        "Smooth Buying & Selling Process",
      ],
    },
    sectionD: {
      aboutTitle: "About Blake Reaves",
      aboutImage: {
        src: "https://u.realgeeks.media/blakesellstriangle/Blake_Resized_Headshot_Red_Shirt.jpg",
        alt: "Blake Reaves Real Estate",
      },
      aboutText: [
        "Blake Reaves is a professional Realtor with Fathom Realty, serving the greater Chapel Hill area.",
        "With years of experience and a passion for helping clients, Blake delivers top-tier guidance through every real estate transaction.",
      ],
    },
    sectionE: {
      profileImage: "https://t2.realgeeks.media/thumbnail/apUNc2EAlSGGJPiSGF7bvzyFpVw=/fit-in/800x172/filters:format(png)/u.realgeeks.media/blakesellstriangle/eba800ab2167-FathomLogo_Email_Primary_Vt_Large.png",
      profileAlt: "Blake Reaves Profile",
      businessName: "Blake Reaves | Fathom Realty",
      contact: {
        phone: "9192718337",
        phoneLabel: "(919) 271-8337",
        email: "blake.reaves@gmail.com",
        website: "https://www.blakesellstriangle.com/blake-reaves/",
        address: "11312 US 15-501 N., Ste. 107-128, Chapel Hill, NC, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "11312 US 15-501 N., Ste. 107-128, Chapel Hill, NC, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.785454144248!2d-79.0487217!3d35.8367828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8859ff1f1913f47d%3A0x213fc5b6fc17df56!2s11312%20US%2015-501%20N%20Ste%20107-128%2C%20Chapel%20Hill%2C%20NC%2027517%2C%20USA!5e0!3m2!1sen!2sph!4v1694759477210!5m2!1sen!2sph",
    },    
  },
};

export default config;
